// helper expression to remove nulls from an array
const removeNull = x => x

export default removeNull
